<template>
  <div class="mine">
    <div class="logo">
      <img
        src="../../../static/qi_logo.png"
        alt=""
        @click="$router.push('/')"
        style="cursor: pointer"
      />
    </div>
    <div class="layout">
      <el-container class="container">
        <el-aside class="aside" style="width: 150px; over-flow: hidden">
          <my-aside />
        </el-aside>
        <el-container>
          <el-header>
            <my-header />
          </el-header>
          <el-main>
            <router-view></router-view>
          </el-main>
        </el-container>
      </el-container>
    </div>
  </div>
</template>
<script>
import MyAside from "./components/MyAside.vue";
import MyHeader from "./components/MyHeader.vue";
import { getUserInfo } from "@/api/index";
export default {
  name: "layOut",
  components: {
    MyAside,
    MyHeader,
  },
  data() {
    return {};
  },
  mounted() {
    this.checkInfo();
  },
  methods: {
    checkInfo() {
      getUserInfo({
        token: localStorage.getItem("token"),
      }).then((res) => {
        localStorage.setItem("userInfo", JSON.stringify(res.data.data));
      });
    },
  },
};
</script>

<style lang="less" scoped>
.mine {
  width: 100%;
  height: 100vh;
  display: flex;
  flex-direction: column;
}
.logo {
  height: 70px;
  img {
    height: 60px;
    margin-left: 20px;
  }
}
.layout {
  flex: 1;
  overflow: hidden;

  .container {
    height: 100%;
  }
  /deep/.is-vertical {
    height: 100%;
    display: flex;
    flex-direction: column;
    .el-header {
      background-color: #f4f6fc;
    }
    .el-main {
      flex: 1;
      overflow: auto;
      background-color: #f4f6fc;
    }
    .el-main::-webkit-scrollbar {
      width: 4px;
    }

    .el-main::-webkit-scrollbar-thumb {
      border-radius: 10px;
      background: #bfbfbf;
    }
    .el-main::-webkit-scrollbar-track {
      border-radius: 0;
      background: #f1f1f1;
    }
  }
  .el-aside {
    background-color: #409eff;
  }
}
</style>
